import React, { useEffect, useRef, useState, SVGProps } from "react";
import { fetchPath } from "../../config/defPath";
import { LotteryBall } from "./LotteryBall";

import { LotteryState } from "../../config/types";

interface PorpsLottery {
    data: LotteryState["lottery"]
    setPage: (id: string) => void
    setCode: (code: string[]) => void
}


export const LotteryFormPage: React.FC<PorpsLottery> = ({ data, setPage, setCode }) => {
    const [errorNumbers, setErrorNumbers] = useState("")
    const [errorScore, setErrorScore] = useState("")
    const [errorTyC, setErrorTyC] = useState("")
    const [errorTime] = useState(5000)

    const inputRefs = [
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
        useRef<HTMLInputElement>(null),
    ];
    const inputScoreRefs = useRef<HTMLInputElement>(null)
    const inputTyC = useRef<HTMLInputElement>(null)

    const handleClick = async (e: any) => {
        e.preventDefault()

        window.dataLayer && window.dataLayer.push({
            "event": "GAEvent",
            "event_category": "Content",
            "event_action": "Button",
            "event_label": "Send Prediction",
            "interaction": "true",
            "component_name": "Modo_Carrera_Lottery",
            "element_text": "Enviar prediccion",
        });

        const numbersList = inputRefs.map((el) => el.current.value)
        const numberScore = inputScoreRefs.current.value

        // Validaciones formulario
        const isEmpty = inputRefs.some((ref) => ref.current.value.trim() === '');
        const isEmptyScore = numberScore.trim() === '';
        const isChackedTyC = inputTyC.current.checked;

        if (isEmpty) {
            setErrorNumbers("No olvides llenar todos los campos para participar en el sorteo")
            return
        }

        if (new Set(numbersList).size !== numbersList.length) {
            setErrorNumbers("Los campos no pueden tener números repetidos")
            return
        }
        
        if (numbersList.includes("0")) {
            setErrorNumbers("Debes ingresar números del 1 al 99")
            return
        }

        if (isEmptyScore) {
            setErrorScore("No olvides llenar todos los campos para participar en el sorteo")
            return
        }

        if (!isChackedTyC) {
            setErrorTyC("Este campo es obligatorio")
            return
        }

        // formulario valido
        const lotteryData = [...numbersList, numberScore]

        sendLottery(lotteryData)
    };

    const sendLottery = async (lotteryData: string[]) => {

        try {
            const response = await fetch(`${fetchPath}/aguila/loyalty/set-lottery`, {
                method: "POST",
                body: JSON.stringify({ lottery: lotteryData.join(","), tyc: 1 })
            })

            const dataRes = await response.json()

            console.log({ dataRes })

            if (dataRes.code === 1) {
                setErrorNumbers(dataRes.message)
                return
            }

            if (dataRes.code === 2) {
                setCode(lotteryData)
                setPage("confirm")
                return
            }

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (errorNumbers.length > 0) setTimeout(() => setErrorNumbers(''), errorTime)
        if (errorScore.length > 0) setTimeout(() => setErrorScore(''), errorTime)
        if (errorTyC.length > 0) setTimeout(() => setErrorTyC(''), errorTime)


    }, [errorNumbers, errorScore, errorTyC])

    return (
        <form className="lottery__content blur-slow">
            <h1 className="lottery__content--title" dangerouslySetInnerHTML={{ __html: data.title.value }}></h1>

            <div className="lottery__positions">
                <div className="lottery__content--subtitle" dangerouslySetInnerHTML={{ __html: data.copy1.value }}></div>

                <div className="lottery__positions--wrapper">
                    <div className="lottery__positions--list">
                        <LotteryBall refEl={inputRefs[0]} placeholder={"1"} />
                        <LotteryBall refEl={inputRefs[1]} placeholder={"5"} />
                        <LotteryBall refEl={inputRefs[2]} placeholder={"8"} />
                        <LotteryBall refEl={inputRefs[3]} placeholder={"9"} />
                        <LotteryBall refEl={inputRefs[4]} placeholder={"11"} />
                    </div>
                    <div className="lottery__positions--list">
                        <LotteryBall refEl={inputRefs[5]} placeholder={"2"} />
                        <LotteryBall refEl={inputRefs[6]} placeholder={"3"} />
                        <LotteryBall refEl={inputRefs[7]} placeholder={"1"} />
                        <LotteryBall refEl={inputRefs[8]} placeholder={"7"} />
                        <LotteryBall refEl={inputRefs[9]} placeholder={"10"} />
                        <LotteryBall refEl={inputRefs[10]} placeholder={"12"} />
                    </div>
                </div>
            </div>

            {
                errorNumbers.length > 0 && (
                    <div className='error-message'>{errorNumbers}</div>
                )
            }

            <div className="lottery__marker">
                <div className="lottery__marker--text" dangerouslySetInnerHTML={{ __html: data.copy2.value }}></div>
                <LotteryBall refEl={inputScoreRefs} marker={true} placeholder={"3"} />
            </div>

            {
                errorScore.length > 0 && (
                    <div className='error-message'>{errorScore}</div>
                )
            }

            <div className="lottery__content--tyc">
                <input type="checkbox" name="tyc" id="lottery-tyc" ref={inputTyC} />
                <label className="lottery__content--tyc--label" htmlFor="lottery-tyc">
                    <SvgCheckout />
                    <div dangerouslySetInnerHTML={{ __html: data.tyc.value }}></div>
                </label>
            </div>

            {
                errorTyC.length > 0 && (
                    <div className='error-message'>{errorTyC}</div>
                )
            }

            <div style={{paddingBottom: "10rem"}}>
                <button className="lottery__content--btn" onClick={handleClick} >{data.btn1}</button>
            </div>

        </form>
    )
}

const SvgCheckout = (props: SVGProps<SVGSVGElement>) => (
    <div className="lottery__checkbox">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={18}
            fill="none"
            {...props}
        >
            <g clipPath="url(#a)">
                <path
                    fill="#000"
                    d="m7 17.045-6.21-6.21 2.83-2.83L7 11.395l9.88-9.89 2.83 2.83L7 17.045Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 .875h20v17H0z" />
                </clipPath>
            </defs>
        </svg>
    </div>
)